import styles from './LdsRoller.module.css';

export default function LdsRoller() {
    return (
        <span className={styles.LdsRing}></span>
    );
}
